import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/apiClient";
import { listUsersApiV1AdminUsersGet } from "@/api/generated/sdk.gen";
import type { AdminUserRowSchema } from "@/api/generated/types.gen";

import { CLIENT_KEYS } from "@constants/clientKeys";

/** List all users (admin). Optional email/name substring filter. */
export const useAdminUsers = ({
  q,
  enabled = true,
}: {
  q?: string;
  enabled?: boolean;
} = {}) => {
  return useQuery({
    queryKey: [CLIENT_KEYS.ADMIN_USERS, q ?? null],
    queryFn: async (): Promise<AdminUserRowSchema[]> => {
      const response = await listUsersApiV1AdminUsersGet({
        client: apiClient,
        query: { q: q || null },
      });
      if ("error" in response && response.error) {
        throw new Error("Failed to load users.");
      }
      return response.data ?? [];
    },
    enabled,
    staleTime: 30 * 1000,
  });
};
